import { FloorBounds } from '../../hooks/useFloorBounds';

export interface MinimapTransform {
  scale: number;
  offsetX: number;
  offsetY: number;
}

/**
 * Calculates scale and offset to fit layout bounds inside the minimap dimensions while keeping aspect ratio.
 */
export function getMinimapTransform(
  bounds: FloorBounds,
  minimapWidth: number,
  minimapHeight: number
): MinimapTransform {
  const boundsWidth = bounds.maxX - bounds.minX;
  const boundsHeight = bounds.maxY - bounds.minY;

  const scale = Math.min(
    minimapWidth / boundsWidth,
    minimapHeight / boundsHeight
  );

  const offsetX = (minimapWidth - boundsWidth * scale) / 2;
  const offsetY = (minimapHeight - boundsHeight * scale) / 2;

  return { scale, offsetX, offsetY };
}

/**
 * Maps world coordinate to minimap coordinate.
 */
export function worldToMinimap(
  x: number,
  y: number,
  bounds: FloorBounds,
  transform: MinimapTransform
): { x: number; y: number } {
  return {
    x: (x - bounds.minX) * transform.scale + transform.offsetX,
    y: (y - bounds.minY) * transform.scale + transform.offsetY,
  };
}

/**
 * Maps minimap coordinate to world coordinate.
 */
export function minimapToWorld(
  x: number,
  y: number,
  bounds: FloorBounds,
  transform: MinimapTransform
): { x: number; y: number } {
  return {
    x: (x - transform.offsetX) / transform.scale + bounds.minX,
    y: (y - transform.offsetY) / transform.scale + bounds.minY,
  };
}
